import React from 'react';
import { Box } from '@mui/material';
import { getImageUrl } from '../../helpers/imageUtils';
import ProductImagePlaceholder from './ProductImagePlaceholder';

export const hasProductImage = (image) =>
  image != null && String(image).trim() !== '';

const ProductImage = ({
  image,
  alt = '',
  placeholderCompact = false,
  sx,
  placeholderSx,
}) => {
  if (!hasProductImage(image)) {
    return <ProductImagePlaceholder compact={placeholderCompact} sx={placeholderSx} />;
  }

  return (
    <Box
      component="img"
      src={getImageUrl(image)}
      alt={alt}
      sx={{
        width: '100%',
        objectFit: 'contain',
        display: 'block',
        ...sx,
      }}
    />
  );
};

export default ProductImage;
